import axios from "axios";

export const getCartItems = () => axios.get("http://localhost:8083/api/cart");
export const updateCartItemQuantity = (cartItemId, quantity) =>
  axios.put(`http://localhost:8083/api/cart/update/${cartItemId}?quantity=${quantity}`);
export const removeCartItem = (cartItemId) =>
  axios.delete(`http://localhost:8083/api/cart/remove/${cartItemId}`);
export const addToCartApi = (giftId, quantity = 1) =>
  axios.post(`http://localhost:8083/api/cart/add/${giftId}?quantity=${quantity}`);
